/* Atelier theme – vanilla JS, no dependencies */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  /* Mobile menu */
  $$('[data-menu-toggle]').forEach((btn) =>
    btn.addEventListener('click', () => {
      const open = btn.closest('[data-header]').classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open);
    })
  );

  /* Auto-submit filter / sort forms */
  $$('[data-autosubmit]').forEach((el) => el.addEventListener('change', () => el.closest('form').submit()));

  /* Carousels: slideshow + product carousel */
  const step = (track, dir) => {
    const first = track.firstElementChild;
    if (!first) return;
    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    track.scrollBy({ left: dir * (first.getBoundingClientRect().width + gap), behavior: 'smooth' });
  };
  $$('[data-carousel]').forEach((root) => {
    const track = $('[data-track]', root);
    $$('[data-dir]', root).forEach((b) => b.addEventListener('click', () => step(track, +b.dataset.dir)));
    const delay = +root.dataset.autoplay;
    if (delay > 0) {
      setInterval(() => {
        const end = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
        end ? track.scrollTo({ left: 0, behavior: 'smooth' }) : step(track, 1);
      }, delay);
    }
  });

  /* Product gallery */
  $$('[data-gallery]').forEach((g) => {
    const track = $('[data-gallery-track]', g);
    const slides = [...track.children];
    const thumbs = $$('[data-thumb]', g);
    const go = (i) => track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
    const sync = () => {
      const i = Math.round(track.scrollLeft / track.clientWidth);
      thumbs.forEach((t, n) => t.classList.toggle('is-active', n === i));
    };
    track.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true });
    thumbs.forEach((t, i) => t.addEventListener('click', () => go(i)));
    $$('[data-dir]', g).forEach((b) =>
      b.addEventListener('click', () => track.scrollBy({ left: +b.dataset.dir * track.clientWidth, behavior: 'smooth' }))
    );
    g.goToMedia = (id) => {
      const i = slides.findIndex((s) => s.dataset.mediaId == id);
      if (i > -1) go(i);
    };
  });

  /* Variant selection: updates hidden id, URL, gallery, price & button via Section Rendering API */
  $$('[data-product-section]').forEach((root) => {
    const variants = JSON.parse($('[data-variants]', root).textContent);
    const idInput = $('[data-variant-id]', root);
    const gallery = $('[data-gallery]', root);
    const groups = $$('[data-option-group]', root);
    if (!groups.length) return;

    const update = async () => {
      const chosen = groups.map((g) => ($('input:checked', g) || {}).value);
      groups.forEach((g) => {
        const label = $('[data-selected-label]', g), c = $('input:checked', g);
        if (label && c) label.textContent = c.value;
      });
      const v = variants.find((x) => x.options.every((o, i) => o === chosen[i]));
      const btn = $('[data-atc]', root);
      if (!v) {
        if (btn) { btn.disabled = true; btn.textContent = root.dataset.unavailableText; }
        return;
      }
      idInput.value = v.id;
      history.replaceState({}, '', `${root.dataset.url}?variant=${v.id}`);
      if (v.featured_media && gallery) gallery.goToMedia(v.featured_media.id);
      try {
        const res = await fetch(`${root.dataset.url}?variant=${v.id}&section_id=${root.dataset.sectionId}`);
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        ['[data-price]', '[data-badge]', '[data-stock]', '[data-atc-wrap]'].forEach((sel) => {
          const fresh = $(sel, doc), old = $(sel, root);
          if (fresh && old) old.replaceWith(fresh);
        });
      } catch (e) { /* keep current UI */ }
    };
    groups.forEach((g) => $$('input', g).forEach((i) => i.addEventListener('change', update)));
  });
})();
